import { render, staticRenderFns } from "./StatementMore.vue?vue&type=template&id=08952638&scoped=true&"
import script from "./StatementMore.vue?vue&type=script&lang=js&"
export * from "./StatementMore.vue?vue&type=script&lang=js&"
import style0 from "./StatementMore.vue?vue&type=style&index=0&id=08952638&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08952638",
  null
  
)

export default component.exports